// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { Module } from "#/components/module/Module";
import { EditWrapper } from "#/components/edit_wrapper/EditWrapper";
import ModuleBase from "#/common/ModuleBase";

@Component({
  mixins: [template],
  components: {
    Module,
    EditWrapper,
  },
})
export class ModuleList extends Vue {
  @Prop({ default: false })
  public isInEditMode!: boolean;

  @Prop({ default: () => [] })
  public modules!: Array<Object>;

  @Prop({ default: "de" })
  public lang!: string;

  @Prop({ default: "GLOBAL" })
  public country!: string;

  @Prop({ default: "auto" })
  public forceBackground!: string;
}
